// Maps contract error codes + wallet RPC errors into user-friendly messages.
const CODE_MAP = {
  OW:   'Only the contract owner can do that.',
  OA:   'Only the admin can do that.',
  OOA:  'Only owner or admin can do that.',
  OM:   'Only the migrator can do that.',
  REG:  'This wallet is already registered.',
  NR:   'Wallet is not registered — please register first.',
  IR:   'Invalid referrer.',
  IU:   'Invalid user.',
  IL:   'Invalid level.',
  II:   'Invalid index.',
  ITF:  'Invalid timeframe.',
  IO:   'Invalid owner address.',
  IA:   'Invalid address.',
  IM:   'Invalid minimum.',
  IMU:  'Invalid multiple.',
  IC:   'Invalid ceiling.',
  MIN:  'Amount is below the minimum investment.',
  MULT: 'Amount must be a multiple of the required step.',
  MAX:  'Maximum user cap reached.',
  MC:   'Amount is below the minimum claim.',
  BL:   'This wallet is blacklisted.',
  BLAO: 'Cannot blacklist owner or admin.',
  NA:   'You have no active investments.',
  NF:   'Not found.',
  TF:   'Token transfer failed. Check USDT balance & allowance.',
  NRC:  'No rewards to claim.',
  E100: 'Value exceeds 100%.',
  F50:  'Fee exceeds 50%.',
  RTH:  'ROI setting too high.',
  SUM:  'Fee split exceeds 100%.',
  TE:   'Too early — please wait until the ROI period ends.',
  NAI:  'No active investment.',
  MF:   'Migration has been finalized.',
  ME:   'Migration ended.'
};

export function parseContractError(err) {
  if (!err) return 'Unknown error.';
  // ethers 5 shapes: err.reason, err.data.message, err.error.message, err.message
  const candidates = [];
  if (err.reason) candidates.push(err.reason);
  if (err.data && err.data.message) candidates.push(err.data.message);
  if (err.error && err.error.message) candidates.push(err.error.message);
  if (err.message) candidates.push(err.message);

  // user rejection
  const joined = candidates.join(' | ').toLowerCase();
  if (err.code === 4001 || joined.includes('user rejected') || joined.includes('user denied')) {
    return 'You rejected the transaction.';
  }
  if (joined.includes('insufficient funds')) return 'Insufficient BNB for gas.';
  if (joined.includes('replacement fee too low')) return 'Wallet rejected: replacement fee too low.';
  if (joined.includes('nonce')) return 'Wallet nonce issue — try again.';

  // Look for a short revert code like "MIN", "TF", "NR"
  for (const raw of candidates) {
    if (!raw) continue;
    const m = raw.match(/revert(?:ed)?[:\s"']*([A-Z]{2,4}[0-9]?)/i)
           || raw.match(/execution reverted[:\s"']*([A-Z]{2,4}[0-9]?)/i)
           || raw.match(/"([A-Z]{2,4}[0-9]?)"/)
           || raw.match(/reason=["']([A-Z]{2,4}[0-9]?)["']/);
    if (m && CODE_MAP[m[1]]) return CODE_MAP[m[1]];
    // Also raw code alone
    const asCode = raw.trim().toUpperCase();
    if (CODE_MAP[asCode]) return CODE_MAP[asCode];
  }

  return candidates[0] || 'Transaction failed.';
}
